<template>
  <div class="modal-column">
    <div class="flex-1 p-20px">
      <Form ref="form" :model="formData" :rules="{}" mode="block">
        <div class="flex">
          <FormItem class="flex-1" label="记账日期" prop="billDate" required>
            <DatePicker :disabled="insert == 'insert'" v-model="formData.billDate" :clearable="false" :option="{start:startDate,end:endDate}"/>
          </FormItem>
          <FormItem class="flex-1 ml-16px" label="收支类别" required prop="ioTypeId">
            <!-- 弹出新增收支类别 -->
            <div style="display:flex;flex-direction:row;align-items:center;">
              <Select :datas="ioTypeOptions" filterable v-model="formData.ioTypeId" :deletable="false"/>
              <ButtonGroup>
                <DropdownMenu button @clickItem="triggers" :datas="dropdownMenu">
                  <span style="fontWeight:1000;padding:0 12px;margin:0;">+</span>
                </DropdownMenu>
              </ButtonGroup>
            </div>
          </FormItem>
        </div>
        <FormItem label="摘要" prop="digest" required>
          <Input type="text" v-model="formData.digest" :maxlength="255"/>
        </FormItem>
        <div class="flex">
          <FormItem class="flex-1 " label="收入(借方)" :required="formData.ioTypeId && (ioTypeMap[formData.ioTypeId] && ioTypeMap[formData.ioTypeId].type==='收')" prop="debit">
            <Input type="number" v-model="formData.debit" :disabled="!formData.ioTypeId || (ioTypeMap[formData.ioTypeId] && ioTypeMap[formData.ioTypeId].type!=='收')"/>
          </FormItem>
          <FormItem class="flex-1 ml-16px" label="支出(贷方)" :required="formData.ioTypeId && (ioTypeMap[formData.ioTypeId] && ioTypeMap[formData.ioTypeId].type==='支')" prop="credit">
            <Input type="number" v-model="formData.credit" :disabled="!formData.ioTypeId || (ioTypeMap[formData.ioTypeId] && ioTypeMap[formData.ioTypeId].type!=='支')"/>
          </FormItem>
          <!--
          <FormItem class="flex-1 ml-16px" label="结算方式" prop="settlementTypeId">
            <Select :datas="settlementTypeOptions" filterable v-model="formData.settlementTypeId"/>
          </FormItem>-->
        </div>
        <div class="flex">
          <FormItem class="flex-1 " label="往来单位" prop="accountingCategoryDetailsId">
            <DropdownCustom ref="categoryDropdown" class="block-dropdown" trigger="manual">
              <Input @click="$refs.categoryDropdown.show()" type="text" v-model="formData.accountingCategoryDetailsValue" readonly/>
              <template #content>
                <CashierAssistingAccounting @selected="onCategorySelected" @clear="onCategoryClear" @close="onCategoryClose"/>
              </template>
            </DropdownCustom>
          </FormItem>
          <FormItem class="flex-1 ml-16px" label="项目" prop="projectCategoryDetailsId">
            <!-- 弹出新增项目 -->
            <div style="display:flex;flex-direction:row;align-items:center;">
              <Select :datas="projectOptions" filterable v-model="formData.projectCategoryDetailsId"/>
              <Button icon="fa fa-plus" @click="openProj"></Button>
            </div>
          </FormItem>
          <FormItem class="flex-1 ml-16px" label="部门" prop="deptCategoryDetailsId">
            <!-- 弹出新增部门 -->
            <div style="display:flex;flex-direction:row;align-items:center;">
              <Select :datas="deptOptions" filterable v-model="formData.deptCategoryDetailsId"/>
              <Button icon="fa fa-plus" @click="openDept"></Button>
            </div>
          </FormItem>
        </div>
        <div class="flex">
          <FormItem class="flex-1" label="票据号" prop="billNo">
            <Input type="text" v-model="formData.billNo" :maxlength="255"/>
          </FormItem>
          <FormItem class="flex-1 ml-16px" label="备注" prop="remark">
            <Input type="text" v-model="formData.remark" :maxlength="255"/>
          </FormItem>
        </div>
      </Form>
    </div>
    <div class="modal-column-btn">
      <Button @click="$emit('close')">取消</Button>
      <Button color="green" @click="submit" :loading="loading">{{ formData.id ? '更新' : '保存' }}</Button>
      <Button color="green" v-if="!formData.id" @click="submitAndNew()" :loading="loading">保存并新增</Button>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "CashierJournalForm"
}
</script>

<script setup>
import {defineProps, reactive, ref, toRefs, defineEmits, watch,h} from "vue";
import CashierJournal from "@/api/CashierJournal";
import {CopyObj} from "@/js/common/utils";
import CashierAssistingAccounting from "@/views/cashier/AssistingAccounting";
//新增部门
import {layer} from "@layui/layer-vue";
import DepartmentForm from "@/views/setting/AssistingAccounting/form/DepartmentForm.vue";
import ProjectForm from "@/views/setting/AssistingAccounting/form/ProjectForm.vue";
import setting from "@/api/setting";
import CashierIoType from "@/api/CashierIoType";
import CashierIoTypeForm from "@/views/cashier/CashierIoTypeForm";

let props = defineProps(['entity', 'account', 'startDate', 'endDate', 'settlementTypeOptions', 'deptOptions', 'projectOptions','insert']);
const {entity, account, startDate, endDate, settlementTypeOptions, deptOptions, projectOptions, insert} = toRefs(props);


let emits = defineEmits(['success', 'close']);

const loading = ref(false);
const form = ref(null);
const categoryDropdown = ref(null);
const ioTypeMap = reactive({});
const ioTypeOptions = ref([]);
const dropdownMenu = [{ title: '新增收入', key: 'in' }, { title: '新增支出', key: 'out' }];

const triggers = (selectedItem) => {
  console.log(selectedItem); // 输出选中的项的 key 值

  const showForm = (entity, title, type) => {
    let layerId = layer.open({
      title: title,
      shadeClose: false,
      closeBtn: false,
      zIndex: 1000,
      area: ['400px', 'auto'],
      content: h(CashierIoTypeForm, {
        entity,
        type: type,
        onClose: () => {
          layer.close(layerId);
        },
        onSuccess: () => {
          loadCashierIoType();
          layer.close(layerId);
        }
      })
    });
  };

  if (selectedItem === "in") {
    showForm(null, "新增收入", "收");
  } else {
    showForm(null, "新增支出", "支");
  }
};


const loadCashierIoType = () => {
  CashierIoType.list().then(({data}) => {
    ioTypeOptions.value = data.map(val => {
      ioTypeMap[val.id] = val;
      return {
        key: val.id,
        title: val.type + "-" + val.code + "-" + val.name
      }
    });
  })
}
loadCashierIoType();

//新增部门
const openDept = (entity) => {
	let layerId = layer.open({
		title: "部门信息",
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		area: ['700px', 'auto'],
		content: h(DepartmentForm, {
			entity,
			onClose: () => {
				layer.close(layerId);
				getDept();
			},
			onSuccess: () => {
				layer.close(layerId);
				getDept();
			}
		})
	});
}
//新增部门
const getDept = () =>{
  setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT', 'VENDOR']).then(({data}) => {
    deptOptions.value = data['DEPARTMENT'].map(val => {
      return {
        key: val.id,
        accountingCategoryId: val.categoryId,
        title: val.name
      }
    });
  })
}

//新增部门
const openProj = (entity) => {
	let layerId = layer.open({
		title: "项目信息",
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		area: ['700px', 'auto'],
		content: h(ProjectForm, {
			entity,
			onClose: () => {
				layer.close(layerId);
				getProj();
			},
			onSuccess: () => {
				layer.close(layerId);
				getProj();
			}
		})
	});
}
//新增部门
const getProj = () =>{
  setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['PROJECT', 'VENDOR']).then(({data}) => {
    projectOptions.value = data['PROJECT'].map(val => {
      return {
        key: val.id,
        accountingCategoryId: val.categoryId,
        title: val.name
      }
    });
  })
}

const formData = reactive({
  "id": null,
  "type": account.value.type,
  "digest": "",
  "serialNumber": "",
  "billDate": endDate.value,
  "accountId": account.value.id,
  "ioTypeId": null,
  "ioTypeValue": "",
  "accountingCategoryId": null,
  "accountingCategoryDetailsId": null,
  "accountingCategoryDetailsValue": "",
  "projectCategoryId": null,
  "projectCategoryDetailsId": null,
  "deptCategoryId": null,
  "deptCategoryDetailsId": null,
  "debit": null,
  "credit": null,
  "remark": null,
  "billNo": null,
  "settlementTypeId": null,
})

const submit = () => {
  if(insert.value == 'insert'){
    let validResult = form.value.valid();
    if (validResult.result) {
      loading.value = true;
      if (formData.projectCategoryDetailsId) {
        formData.projectCategoryId = projectOptions.value.find(val => val.key === formData.projectCategoryDetailsId).accountingCategoryId;
      } else {
        formData.projectCategoryId = null;
      }
      if (formData.deptCategoryDetailsId) {
        formData.deptCategoryId = deptOptions.value.find(val => val.key === formData.deptCategoryDetailsId).accountingCategoryId;
      } else {
        formData.deptCategoryId = null;
      }
      CashierJournal.saveAndInsert(formData,formData.id).then(() => {
        emits('success');
      }).finally(() => loading.value = false)
    }
  }else{
    let validResult = form.value.valid();
    if (validResult.result) {
      loading.value = true;
      if (formData.projectCategoryDetailsId) {
        formData.projectCategoryId = projectOptions.value.find(val => val.key === formData.projectCategoryDetailsId).accountingCategoryId;
      } else {
        formData.projectCategoryId = null;
      }
      if (formData.deptCategoryDetailsId) {
        formData.deptCategoryId = deptOptions.value.find(val => val.key === formData.deptCategoryDetailsId).accountingCategoryId;
      } else {
        formData.deptCategoryId = null;
      }
      CashierJournal.save(formData).then(() => {
        emits('success');
      }).finally(() => loading.value = false)
    }
  }
}

const submitAndNew = () => {
  let validResult = form.value.valid();
  if (validResult.result) {
    loading.value = true;
    if (formData.projectCategoryDetailsId) {
      formData.projectCategoryId = projectOptions.value.find(val => val.key === formData.projectCategoryDetailsId).accountingCategoryId;
    } else {
      formData.projectCategoryId = null;
    }
    if (formData.deptCategoryDetailsId) {
      formData.deptCategoryId = deptOptions.value.find(val => val.key === formData.deptCategoryDetailsId).accountingCategoryId;
    } else {
      formData.deptCategoryId = null;
    }
    console.log(formData)
    CashierJournal.save(formData).then(() => {
      // emits('success');
      formData.id=null;
      formData.type= account.value.type;
      formData.digest= "";
      formData.serialNumber= "";
      formData.debit= null;
      formData.credit= null;
      formData.remark= null;
      formData.billNo= null;
      formData.settlementTypeId= null;
      formData.projectCategoryDetailsId = null;
      formData.deptCategoryDetailsId = null;
      formData.accountingCategoryDetailsValue = null;
    }).finally(() => loading.value = false)
  }
}

const onCategorySelected = ({categoryId, id, name, code}) => {
  console.log(categoryId, id, name, code)
  formData.accountingCategoryDetailsId = id;
  formData.accountingCategoryDetailsValue = code + "-" + name;
  formData.accountingCategoryId = categoryId;
  categoryDropdown.value.hide();
}

const onCategoryClear = () => {
  formData.accountingCategoryDetailsId = null;
  formData.accountingCategoryDetailsValue = null;
  formData.accountingCategoryId = null;
  categoryDropdown.value.hide();
}

const onCategoryClose = () => {
  categoryDropdown.value.hide();
}

watch(() => formData.ioTypeId, (value, oldValue) => {
  if (oldValue) {
    const newType = ioTypeMap[value];
    const oldType = ioTypeMap[oldValue];

    if (newType.type !== oldType.type) {
      const {debit, credit} = formData;
      formData.debit = credit;
      formData.credit = debit;
    }
  }
})

CopyObj(formData, entity.value);
</script>
